import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded, FuseAnimateGroup } from '@fuse';
import AssignmentForm from './AssignmentForm';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button, Tab, Tabs, Grid, Divider, DialogTitle, DialogContent, DialogActions, Dialog, TextField, Typography, List, ListItem, Tooltip, Icon, Table, TableRow, TableBody, TableCell, TableHead } from '@material-ui/core';
import * as Actions from './store/actions';
import ModelAssetList from '../asset/ModelAssetList';
import RelationUpdateTabs from '../../components/RelationUpdateTabs';
import StaticRelationList from '../../components/StaticRelationList';
import * as validatorActions from '../../components/validator/store/actions';
import CourseBuilderHeader from '../../components/CourseBuilderHeader';
import TabPanelButtons from '../../components/TabPanelButtons';
import RichTextEditor from 'react-rte';
import _ from 'lodash';
import * as paramActions from '../../components/paramHistory/store/actions';
import * as CompanyActions from '../company/store/actions';
import { getSharedTextFieldProps } from '../../components/helpers';
import PageHeader from 'main/components/PageHeader';
import EventUsage from 'main/components/event/EventUsage';
import EventUsageDialog from 'main/components/event/EventUsageDialog';
import AssignmentPreview from './AssignmentPreview';

const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64,
        flex: 1
    },
    tabRoot: {
        height: 64,
        [theme.breakpoints.up('md')]: {
            minWidth: '144px'
        },
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
        minWidth: '80%',
        maxWidth: '80%'
    },
});

class Assignment extends Component {
    state = {
        current_tab: 0,
        assignment_id: 0,
        view_type: '',
        tabValue: 0,
        rte_value: RichTextEditor.createEmptyValue(),
        deleteDialogActive: false,
        copyDialogActive: false,
        usageDialogActive: false,
        lockDialogActive: false,
        unlockDialogActive: false,
        activateDialogActive: false
    }

    constructor(props) {
        super(props);

        const assignment_id = this.props.match.params.assignment_id;
        const view_type = this.props.match.params.view_type;

        this.state = {
            ...this.state,
            assignment_id: assignment_id,
            view_type: view_type,
        }

        this.props.updateAssignmentLoaded(false);

        if (view_type !== 'create') {
            this.props.getAssignmentData(assignment_id);
        }
        else {

            this.props.updateAssignmentLoaded(true);
            this.props.getAllLessons();
            this.props.getAllQuizzes();
            this.props.getCompanyList();
        }

        const validationList = [
            {
                field_name: 'AssignmentName', functionName: ['checkRequiredFilled']
            }
        ]

        this.props.startValidator(validationList)
    }

    componentDidUpdate = (prevProps, prevState) => {
        const { isAssignmentLoaded, currentAssignment, repullAssignment } = this.props;

        if (this.state.current_tab === 1) {
            const x = document.getElementsByClassName('DraftEditor-root')

            if (x.length > 0) {
                x[0].style.height = '740px'
            }
        }

        // console.log(parseInt(this.props.match.params.assignment_id),  currentAssignment.header.assignment_id)
        if (!_.isEqual(parseInt(this.props.match.params.assignment_id), currentAssignment.header.assignment_id) && this.props.repullAssignment) {
            this.props.updateAssignmentLoaded(false);
            this.props.getAssignmentData(this.props.match.params.assignment_id);
            this.props.getAllLessons();
            this.props.getAllQuizzes();

            this.setState({
                ...this.state,
                current_tab: 0,
                copyDialogActive: false
            })
        }

        if (
            !_.isEqual(isAssignmentLoaded, prevProps.isAssignmentLoaded) || this.props.NeedToResetRTE
        ) {
            this.setState({
                rte_value: RichTextEditor.createValueFromString(currentAssignment.header.AssignmentContent, 'html')
            });
            this.props.handleUpdateRTE()
        }
    }

    onEditorStateChange = (rte_value) => {
        this.setState({ rte_value });
        const field_name = 'AssignmentContent';
        const update_data = {
            [field_name]: rte_value.toString('html')
        };
        this.props.updateAssignmentForm(update_data);
    }

    handleChangeTab = (event, value) => {
        this.setState({
            ...this.state,
            current_tab: value
        })
    }

    handleTabChange = (event, value) => {
        this.setState({ tabValue: value });
    };

    handleActivateDialogOpen = () => {
        this.setState({ activateDialogActive: true });
    }

    handleChangeIndex = index => {
        this.setState({ value: index });
    };

    handleLessonSearchChange = (e) => {
        this.props.lessonUpdateSearch(e.target.value);
    }

    handleQuizSearchChange = (e) => {
        this.props.quizUpdateSearch(e.target.value);
    }

    handleLockDialogOpen = () => {
        this.setState({ lockDialogActive: true });
    }

    handleUnlockDialogOpen = () => {
        this.setState({ unlockDialogActive: true });
    }

    handleActivate = () => {
        this.props.activateAssignment(this.props.currentAssignment.header.assignment_id, this.props.auth.user.data.auth_id, this.props.currentAssignmentLessonList);
        this.setState({ activateDialogActive: false });
        return true
    }

    handleSaveDialogCheck = () => {
        const { event_usage } = this.props;

        if (typeof event_usage !== 'undefined' && event_usage.event_list.length > 0) {
            this.setState({
                usageDialogActive: true
            })
        } else {
            this.handleSubmit('not_in_use');
        }
    }

    handleSubmit = (event_course_status) => {
        const builderActive = this.props.paramHistory.active;
        const lesson_id = this.props.paramHistory.lesson_id;
        const {
            currentAssignment,
            currentAssignmentLessonList,
            currentAssignmentQuizList,
            saveAssignment,
            auth,
            companies
        } = this.props;

        switch (this.state.view_type) {
            case ("create"):
                {
                    this.props.updateAssignmentListLoaded(false)
                    saveAssignment(currentAssignment, currentAssignmentQuizList, auth.user.data.auth_id, event_course_status, companies);

                    if (builderActive) {
                        this.props.history.push('/lesson/edit/' + lesson_id);
                    }
                    else {
                        this.props.history.push('/assignment/list');
                    }
                    break;
                }

            case ("edit"):
                {
                    this.props.updateAssignmentListLoaded(false)
                    saveAssignment(currentAssignment, currentAssignmentQuizList, auth.user.data.auth_id, event_course_status, companies);

                    if (builderActive) {
                        this.props.history.push('/lesson/edit/' + lesson_id);
                    }
                    else {
                        this.props.history.push('/assignment/list');
                    }
                    break;
                }

            default:
                {

                }
        }
    }

    handleDeleteDialogOpen = () => {
        this.setState({ deleteDialogActive: true })
    }

    getDeleteDialog = (active, assignment) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ deleteDialogActive: false })}
            >
                <DialogTitle> Confirm Deactivate {assignment.AssignmentName}?</DialogTitle>
                <DialogContent>
                    {this.props.deleteAllowed ? null :
                        <React.Fragment>
                            <Typography variant="h6">The following relationships will be deactivated:</Typography>

                            {this.props.currentAssignmentLessonList.length > 0 ?
                                <React.Fragment>
                                    <Typography variant="h6">Lessons</Typography>
                                    {this.props.currentAssignmentLessonList.map(l => {
                                        return (
                                            <Typography variant="body" key={l.lesson_id}>{l.LessonName}</Typography>
                                        )
                                    })}
                                </React.Fragment>
                                : null
                            }

                            {this.props.events.length > 0 ?
                                <React.Fragment>
                                    <Typography variant="h6">Calendars</Typography>
                                    {this.props.events.map(e => {
                                        return (
                                            <Typography variant="body" key={e.company_calendar_event_id}>{e.CompanyName}, Instances: {e.Instances}</Typography>
                                        )
                                    })}
                                </React.Fragment>
                                : null
                            }

                            {this.props.currentAssignmentQuizList.length > 0 ?
                                <React.Fragment>
                                    <Typography variant="h6">Quizzes</Typography>
                                    {this.props.currentAssignmentQuizList.map(q => {
                                        return (
                                            <Typography variant="body1" key={q.quiz_id}>{q.QuizName}</Typography>
                                        )
                                    })}
                                </React.Fragment>
                                : null
                            }

                        </React.Fragment>

                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleDelete()} color="primary">
                        Deactivate
                        </Button>
                    <Button onClick={() => this.setState({ deleteDialogActive: false })} color="primary" autoFocus>
                        Go Back
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }

    getActivateDialog = (active, assignment) => {
        return (
            <Dialog
                // maxWidth={'md'}
                // fullWidth
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ activateDialogActive: false })}
            >
                <DialogTitle>Confirm Activate {assignment.AssignmentName}?</DialogTitle>
                <DialogContent>
                    {this.props.deleteAllowed ? null :
                        <React.Fragment>
                            <Typography variant="h6">These relations will be Activated:</Typography>

                            {this.props.currentAssignmentLessonList.length > 0 ?
                                <React.Fragment>
                                    <Typography variant="h6">Lessons</Typography>
                                    <Grid container spacing={8}>
                                        {this.props.currentAssignmentLessonList.map(l => {
                                            return (
                                                <React.Fragment key={l.lesson_id}>
                                                    {l.conflict ?
                                                        <React.Fragment>
                                                            <Grid item xs={1}>
                                                                <Tooltip
                                                                    style={{ display: 'block' }}
                                                                    title={
                                                                        <React.Fragment>
                                                                            <div>This Lessons's Assignment will be overwritten</div>
                                                                            <div>{l.conflict[0].AssignmentName}</div>
                                                                        </React.Fragment>
                                                                    }
                                                                >
                                                                    <Icon>error</Icon>
                                                                </Tooltip>
                                                            </Grid>
                                                            <Grid item xs={11}>
                                                                <Typography variant="body1" >{l.LessonName}</Typography>
                                                            </Grid>
                                                        </React.Fragment>
                                                        :
                                                        <Grid item xs={12}>
                                                            <Typography variant="body1" >{l.LessonName}</Typography>
                                                        </Grid>
                                                    }
                                                </React.Fragment>

                                            )
                                        })}
                                    </Grid>
                                </React.Fragment>
                                : null
                            }

                            {this.props.events.length > 0 ?
                                <React.Fragment>
                                    <Typography variant="h6">Calendars</Typography>
                                    {this.props.events.map(e => {
                                        return (
                                            <Typography variant="body" key={e.company_calendar_event_id}>{e.CompanyName}, Instances: {e.Instances}</Typography>
                                        )
                                    })}
                                </React.Fragment>
                                : null
                            }

                            {this.props.currentAssignmentQuizList.length > 0 ?
                                <React.Fragment>
                                    <Typography variant="h6">Quizzes</Typography>
                                    {this.props.currentAssignmentQuizList.map(q => {
                                        return (
                                            <Typography variant="body1" key={q.quiz_id}>{q.QuizName}</Typography>
                                        )
                                    })}
                                </React.Fragment>
                                : null
                            }

                        </React.Fragment>

                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleActivate()} color="primary">
                        Activate
                        </Button>
                    <Button onClick={() => this.setState({ activateDialogActive: false })} color="primary" autoFocus>
                        Go Back
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }

    handleDelete = () => {
        const builderActive = this.props.paramHistory.active;
        const lesson_id = this.props.paramHistory.lesson_id;
        switch (this.state.view_type) {
            case ("edit"):
                {
                    this.props.deleteAssignment(this.props.currentAssignment.header.assignment_id, this.props.auth.user.data.auth_id);
                    if (builderActive) {
                        this.props.history.push('/lesson/edit/' + lesson_id);
                    }
                    else {
                        this.props.history.push('/assignment/list');
                    }
                    break;
                }

            default:
                {

                }
        }
    }

    handleBack = () => {
        const { paramHistory } = this.props;
        if (paramHistory.lessonCycleActive) {
            return this.props.history.push('/lesson/edit/' + paramHistory.lesson_id)
        }
        else {
            this.props.updatePageHeader({ LessonName: '', lessonCycleActive: false, active: false });
            this.props.toggleAssignmentRepull(true)
            return this.props.history.goBack()
        }

    }

    disableSave = () => {
        const { validator } = this.props;
        const { view_type } = this.state

        switch (view_type) {
            case ("edit"): {
                return (
                    validator.map(v => v.error)
                        .includes(true)
                )
            }
            case ('create'): {
                return !(
                    validator.every(v => v.error === false)
                )
            }
        }
    };

    handleLock = () => {
        this.props.lockAssignment(this.props.currentAssignment.header.assignment_id, this.props.auth.user.data.auth_id);
        this.setState({ lockDialogActive: false });
        return true
    }

    handleUnlock = () => {
        this.props.unlockAssignment(this.props.currentAssignment.header.assignment_id);
        this.setState({ unlockDialogActive: false });
        return true
    }

    handleCompanySearchChange = (e) => {
        this.props.companyUpdateSearch(e.target.value)
    }

    getPageContent = (current_tab, view_type) => {
        const {
            classes,
            theme,
            currentAssignmentLessonList,
            allLessons,
            currentAssignmentQuizList,
            allQuizzes,
            event_usage,
        } = this.props;

        const toolbarConfig = {
            // Optionally specify the groups to display (displayed in the order listed).
            display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS'],
            INLINE_STYLE_BUTTONS: [
                { label: 'Bold', style: 'BOLD', className: 'custom-css-class' },
                { label: 'Italic', style: 'ITALIC' },
                { label: 'Underline', style: 'UNDERLINE' }
            ],
            BLOCK_TYPE_DROPDOWN: [
                { label: 'Normal', style: 'unstyled' },
                { label: 'Heading Large', style: 'header-one' },
                { label: 'Heading Medium', style: 'header-two' },
                { label: 'Heading Small', style: 'header-three' }
            ],
            BLOCK_TYPE_BUTTONS: [
                { label: 'UL', style: 'unordered-list-item' },
                { label: 'OL', style: 'ordered-list-item' },
            ],
        };
        const allowedAssetTypesForEmbed = ['mp3', 'mp4', 'mov', 'avi', 'wmv', 'jpg', 'jpeg', 'png', 'svg', 'gif', 'tiff', 'bmp'];

        const embedAssets = this.props.currentAssignment.assetList.filter(a => allowedAssetTypesForEmbed.includes(a.header.AssetFormat));

        const currentQuizTab = currentAssignmentQuizList.map(q => {
            return {
                label: q.QuizName,
                id: q.quiz_id,
            }
        });

        const addQuizTabData = allQuizzes.map(q => {
            return {
                label: q.QuizName,
                id: q.quiz_id,
            }
        })

        switch (current_tab) {
            case (0): // Detail
                {
                    return (
                        <AssignmentForm
                            view_type={view_type}
                        />
                    );
                }
            case (1): // Content
                {
                    return (
                        <Grid container spacing={8}>
                            <Grid item xs={8}>
                                <RichTextEditor
                                    toolbarConfig={toolbarConfig}
                                    value={this.state.rte_value}
                                    onChange={this.onEditorStateChange}
                                    className='h-full'
                                    readOnly={view_type === 'detail'}
                                />
                            </Grid>
                            <Grid item xs={4}>

                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Parameter</TableCell>
                                            <TableCell>Options</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>Asset Tag</TableCell>
                                            <TableCell>Asset's 6 character tag</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Asset Size</TableCell>
                                            <TableCell>sm (small), md (medium), lg (large)</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Asset Placement</TableCell>
                                            <TableCell>left, center, right</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                                <Typography variant="body1">Available Assets</Typography>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Asset</TableCell>
                                            <TableCell>Tag</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {embedAssets.map(asset => {
                                            return (
                                                <TableRow key={asset.header.asset_id}>
                                                    <TableCell>{asset.header.AssetNewName}</TableCell>
                                                    <TableCell>{`[${asset.header.AssetTag}-md-center]`}</TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>

                                </Table>

                            </Grid>
                        </Grid>

                    )
                }
            case (99): // Relation
                {
                    return (
                        view_type === 'detail' ?
                            <Grid container spacing={24}>
                                <Grid item xs={6}>
                                    <StaticRelationList
                                        rootClass={classes.root}
                                        items={currentQuizTab}
                                        header='Quizzes'
                                    />
                                </Grid>
                            </Grid>
                            :
                            <Grid container spacing={24}>
                                <Grid item xs={6}>
                                    <RelationUpdateTabs
                                        currentRelationsTabData={currentQuizTab}
                                        handleDelete={this.props.toggleQuiz}
                                        handleAdd={this.props.toggleQuiz}
                                        availableObjectList={addQuizTabData}
                                        handleSearchChange={this.handleQuizSearchChange}
                                        leftHeader="Current Quizzes"
                                        rightHeader="Available Quizzees"
                                        search={this.props.quizSearch}
                                        view_type={view_type}
                                        rootClass={classes.root}
                                        dir={theme.direction}
                                    />
                                </Grid>
                            </Grid>
                    );
                }

            case (2): // Asset
                {
                    return (
                        <ModelAssetList
                            view_type={view_type}
                            model_type='assignment'
                            model_id={this.props.currentAssignment.header.assignment_id}
                            file_type="Assignment File"
                            assetList={this.props.currentAssignment.assetList}
                            getAssetList={this.props.getAssignmentAssetList}
                            updateAssetNameFunc={this.props.updateAssetName}
                        />
                    );
                }

            case (3): // Event Usage
                {
                    return (
                        <EventUsage
                            view_type={view_type}
                            event_usage={event_usage}
                        />
                    )
                }
            case (4): // Preview
                {
                    return (
                        <AssignmentPreview
                            currentAssignment={this.props.currentAssignment}
                        />
                    )
                }
            case (5): // Company
                {
                    return (
                        view_type === 'detail' ?
                            <Grid container spacing={24}>
                                <Grid item xs={6}>
                                    <StaticRelationList
                                        rootClass={classes.root}
                                        items={this.props.companies}
                                        header='Companies'
                                    />
                                </Grid>
                            </Grid>
                            :
                            <RelationUpdateTabs
                                currentRelationsTabData={this.props.companies}
                                handleDelete={this.props.toggleCompany}
                                availableObjectList={this.props.allCompanies}
                                handleAdd={this.props.toggleCompany}
                                handleSearchChange={this.handleCompanySearchChange}
                                search={this.props.companySearch}
                                leftHeader="Current Companies"
                                rightHeader="All Companies"
                                view_type={view_type}
                                rootClass={classes.root}
                                dir={theme.direction}
                            />
                    );
                }
            default:
                {
                    return <React.Fragment>Error: No tab found.</React.Fragment>
                }
        }
    }

    getLockDialog = (active) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ lockDialogActive: false })}
            >
                <DialogTitle>Lock Assignment?</DialogTitle>
                <DialogContent>
                    Only you and Company Admin level users will be able to edit the assignment.
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleLock()} color="primary">
                        Lock
                        </Button>
                    <Button onClick={() => this.setState({ lockDialogActive: false })} color="primary" autoFocus>
                        Go Back
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }

    getUnlockDialog = (active) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ unlockDialogActive: false })}
            >
                <DialogTitle>Unlock Assignment?</DialogTitle>
                <DialogContent>
                    All company instructors will be able to edit this assignment.
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleUnlock()} color="primary">
                        Unlock
                        </Button>
                    <Button onClick={() => this.setState({ unlockDialogActive: false })} color="primary" autoFocus>
                        Go Back
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }

    getLockButtonDisplay = () => {
        const role = this.props.auth.user.role;
        const auth_id = this.props.auth.user.data.auth_id;

        // early return if its already locked
        if (this.props.currentAssignment.header.IsLocked === 1) {
            return false;
        }

        if (role === 'dev' || role === 'admin' || role === 'company') {
            return true;
        }
        else if (role === 'instructor' && auth_id === this.props.currentAssignment.header.CreateAuthID) {
            return true;
        }
        return false;
    }

    getUnlockButtonDisplay = () => {
        const role = this.props.auth.user.role;
        const auth_id = this.props.auth.user.data.auth_id;
        // early return if its not locked
        if (this.props.currentAssignment.header.IsLocked === 0) {
            return false;
        }

        if (role === 'dev' || role === 'admin' || role === 'company') {
            return true;
        }
        else if (role === 'instructor' && auth_id === this.props.currentAssignment.header.CreateAuthID) {
            return true;
        }
        return false;
    }

    hideLockedAssignmentActions = () => {
        const role = this.props.auth.user.role;
        const auth_id = this.props.auth.user.data.auth_id;

        if (this.props.currentAssignment.header.IsLocked === 0) {
            return false;
        }

        if (role === 'dev' || role === 'admin' || role === 'company') {
            return false;
        }
        else if (role === 'instructor' && auth_id === this.props.currentAssignment.header.LockedByAuthID) {
            return false;
        }
        return true;
    }

    getCopyDialog = (active, assignment) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ copyDialogActive: false })}
                fullWidth
                maxWidth={'md'}

            >
                <DialogTitle>Choose a new name</DialogTitle>

                <TextField
                    required
                    id="NewAssignmentName"
                    label="New Assignment Name"
                    value={this.props.NewAssignmentName}
                    onChange={(e) => this.props.updateNewAssignmentName(e.target.value)}
                    {...getSharedTextFieldProps(this.state.view_type, this.props.classes)}
                />

                <DialogActions>
                    <Button onClick={() => this.createCopy(true)} color="primary">
                        Create Copy
                    </Button>

                    <Button onClick={() => this.setState({ copyDialogActive: false })} color="primary" autoFocus>
                        Back
                    </Button>
                </DialogActions>

            </Dialog>
        )
    }

    handleCopyClick = () => {
        this.setState({ copyDialogActive: true })
    }

    createCopy = (save) => {
        const { currentAssignment, currentAssignmentQuizList, auth, companies, event_course_status } = this.props
        return this.props.saveAssignmentCopy(
            {
                ...currentAssignment,
                header: {
                    ...currentAssignment.header,
                    AssignmentName: this.props.NewAssignmentName,
                    assignment_id: 0,
                    CopiedFromID: this.props.currentAssignment.header.assignment_id,
                    companies: companies.map(c => {
                        return {
                            company_id: c.id
                        }
                    })
                }
            },
            currentAssignmentQuizList.map(q => { return { ...q, assignment_quiz_rel_id: null } }),
            auth.user.data.auth_id,
        )

    }

    render() {
        const { classes, currentAssignment, isAssignmentLoaded } = this.props;
        const { current_tab, view_type } = this.state;
        const delete_dialog = this.getDeleteDialog(this.state.deleteDialogActive, this.props.currentAssignment.header);
        const copy_dialog = this.getCopyDialog(this.state.copyDialogActive, this.props.currentAssignment)
        const lock_dialog = this.getLockDialog(this.state.lockDialogActive);
        const unlock_dialog = this.getUnlockDialog(this.state.unlockDialogActive);
        const activate_dialog = this.getActivateDialog(this.state.activateDialogActive, this.props.currentAssignment);
        const authRole = this.props.auth.user.data.role_info.role_id;

        const deleteTooltipContent =
            <React.Fragment>
                {this.props.currentAssignmentLessonList.length > 0 ? <h5>Lessons depending on this assignment:</h5> : null}
                {this.props.currentAssignmentLessonList.map(l => {
                    return (
                        <div key={l.lesson_id}>{l.LessonName}</div>
                    )
                })}
                {this.props.events.length > 0 ? <h5>Calendars with this assignment:</h5> : null}
                {this.props.events.map(e => {
                    return (
                        <div key={e.company_calendar_event_id}>{e.CompanyName}, Instances: {e.Instances}</div>
                    )
                })}
            </React.Fragment>

        let header_content = (
            <PageHeader
                component_name={currentAssignment.header.AssignmentName}
                component_type={"assignment"}
                view_type={view_type}
            />
        );

        if (this.props.paramHistory.active) {
            header_content = <CourseBuilderHeader activeStep={2} baseComponent={'event'} />
        }

        let page_content = <React.Fragment>Loading...</React.Fragment>;
        if (isAssignmentLoaded) {
            page_content = this.getPageContent(current_tab, view_type);
        }

        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot,
                    toolbar: classes.layoutToolbar
                }}
                header={
                    header_content
                }
                contentToolbar={
                    <div style={{ width: '100%', height: '100%' }}>
                        <Grid container>
                            <Tabs
                                value={current_tab}
                                onChange={this.handleChangeTab}
                                indicatorColor="primary"
                                textColor="primary"
                                classes={{
                                    root: classes.tabsRoot
                                }}
                                scrollable={true}
                            >
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Detail"
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Content"
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Asset"
                                // disabled={view_type === 'create'}
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Editing Conflicts"
                                    disabled={view_type === 'create'}
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Preview"
                                // disabled={view_type === 'create'}
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Company"
                                    // disabled={view_type === 'create'}
                                    hidden={authRole > 2}
                                />
                            </Tabs>
                            <TabPanelButtons
                                component_name={"assignment"}
                                view_type={view_type}
                                button_list={[
                                    {
                                        display: "unlock",
                                        type: "lock",
                                        onClick: this.handleUnlockDialogOpen,
                                        hidden: !this.getUnlockButtonDisplay() || view_type != 'edit'
                                    },
                                    {
                                        display: "lock",
                                        type: "lock",
                                        onClick: this.handleLockDialogOpen,
                                        hidden: !this.getLockButtonDisplay() || view_type != 'edit'
                                    },
                                    {
                                        display: "Save",
                                        type: view_type === 'create' ? 'create' : 'update',
                                        onClick: this.handleSaveDialogCheck,
                                        disabled: this.disableSave(),
                                        hidden: this.hideLockedAssignmentActions()
                                    },
                                    {
                                        display: "Copy",
                                        type: "update",
                                        onClick: this.handleCopyClick,
                                        disabled: view_type != 'edit',
                                        hidden: view_type === 'create' || this.props.paramHistory.active
                                    },
                                    {   
                                        display: 'deactivate',
                                        type: "delete",
                                        largeLabel: true,
                                        onClick: this.handleDeleteDialogOpen,
                                        // disabled: !this.props.deleteAllowed,
                                        // tooltip: { active: !this.props.deleteAllowed, content: deleteTooltipContent },
                                        hidden: this.hideLockedAssignmentActions() || this.props.currentAssignment.header.Active === 0
                                    },
                                    {
                                        type: "activate",
                                        largeLabel: true,
                                        onClick: this.handleActivateDialogOpen,
                                        // disabled: !this.props.deleteAllowed,
                                        hidden: this.hideLockedAssignmentActions() || this.props.currentAssignment.header.Active === 1

                                    },
                                    {
                                        type: "back",
                                        onClick: () => this.handleBack(),
                                    }
                                ]}
                            />
                        </Grid>
                    </div>
                }
                content={
                    <React.Fragment>
                        <div className="p-24 h-full">
                            <EventUsageDialog
                                event_usage={this.props.event_usage}
                                active={this.state.usageDialogActive}
                                onCloseDialog={() => this.setState({ usageDialogActive: false })}
                                onSubmitDialog={(event_course_status) => this.handleSubmit(event_course_status)}
                            />
                            {unlock_dialog}
                            {lock_dialog}
                            {delete_dialog}
                            {copy_dialog}
                            {page_content}
                            {activate_dialog}
                        </div>
                    </React.Fragment>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getAssignment: Actions.getAssignment,
        getAssignmentData: Actions.getAssignmentData,
        saveAssignment: Actions.saveAssignment,
        deleteAssignment: Actions.deleteAssignment,
        updateAssignmentLoaded: Actions.updateAssignmentLoaded,
        startValidator: validatorActions.startValidator,
        getAssignmentAssetList: Actions.getAssignmentAssetList,
        updateAssignmentForm: Actions.updateAssignmentForm,
        createCopy: Actions.createCopy,
        handleUpdateRTE: Actions.handleUpdateRTE,
        saveAssignmentCopy: Actions.saveAssignmentCopy,
        updateNewAssignmentName: Actions.updateNewAssignmentName,
        companyUpdateSearch: Actions.companyUpdateSearch,
        toggleCompany: Actions.toggleCompany,

        lockAssignment: Actions.lockAssignment,
        unlockAssignment: Actions.unlockAssignment,

        updatePageHeader: paramActions.updateCourseBuilderParams,
        updateAssignmentForm: Actions.updateAssignmentForm,
        toggleAssignmentRepull: Actions.toggleAssignmentRepull,

        // Lessons
        getAllLessons: Actions.getAllLessons,
        toggleLesson: Actions.toggleLesson,
        lessonUpdateSearch: Actions.lessonUpdateSearch,
        updateAssignmentLessons: Actions.updateAssignmentLessons,

        // Quizzes
        getAllQuizzes: Actions.getAllQuizzes,
        toggleQuiz: Actions.toggleQuiz,
        quizUpdateSearch: Actions.quizUpdateSearch,
        updateAssignmentQuizzes: Actions.updateAssignmentQuizzes,
        updateAssignmentListLoaded: Actions.updateAssignmentListLoaded,

        getCompanyList: Actions.getCompanyList,
        activateAssignment: Actions.activateAssignment,
        updateAssetName: Actions.updateAssetName
    }, dispatch);
}

function mapStateToProps({ assignmentApp, auth, validator, paramHistory }) {
    return {
        isAssignmentLoaded: assignmentApp.assignments.isAssignmentLoaded,
        currentAssignment: assignmentApp.assignments.currentAssignment,
        currentAssignmentImage: assignmentApp.assignments.currentAssignmentImage,

        // Lessons
        currentAssignmentLessonList: assignmentApp.assignments.currentAssignmentLessonList,
        allLessons: assignmentApp.assignments.allLessons,
        lessonSearch: assignmentApp.assignments.lessonSearch,

        // Quizzes
        currentAssignmentQuizList: assignmentApp.assignments.currentAssignmentQuizList,
        allQuizzes: assignmentApp.assignments.allQuizzes,
        quizSearch: assignmentApp.assignments.quizSearch,

        events: assignmentApp.assignments.events,
        event_usage: assignmentApp.assignments.event_usage,
        deleteAllowed: assignmentApp.assignments.deleteAllowed,
        validator: validator.list,
        paramHistory: paramHistory.courseBuilder,

        repullAssignment: assignmentApp.assignments.repullAssignment,
        copied_from_id: assignmentApp.assignments.copied_from_id,
        NeedToResetRTE: assignmentApp.assignments.NeedToResetRTE,
        NewAssignmentName: assignmentApp.assignments.NewAssignmentName,

        companies: assignmentApp.assignments.companies,
        allCompanies: assignmentApp.assignments.allCompanies,
        companySearch: assignmentApp.assignments.companySearch,
        auth,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Assignment)));



// WEBPACK FOOTER //
// src/main/content/assignment/Assignment.js